import { createContext, PropsWithChildren, useCallback, useState } from 'react'

interface ISidebarSettings {
  isOpen: boolean
  toggleOpen: () => void
}

interface Props extends PropsWithChildren {}

export const SidebarSettingsContext = createContext<ISidebarSettings | null>(null)

export function SidebarSettingsProvider({ children }: Props) {
  const [isSidebarOpen, setSidebarOpen] = useState(true)
  const toggleSidebar = useCallback(() => {
    setSidebarOpen((old) => !old)
  }, [])

  return (
    <SidebarSettingsContext.Provider
      value={{ isOpen: isSidebarOpen, toggleOpen: toggleSidebar }}
    >
      {children}
    </SidebarSettingsContext.Provider>
  )
}
